import React, { useContext } from 'react';
import styled from 'styled-components';

import { Icon, theme } from 'components';
import TourEditContext from '../TourEditContext';
import { StyledDivider } from '../StyledComponents';
import DotSeparator from './DotSeparator';

export interface TravelTimeProps {
  itemId: string;
}

const formatDistance = (distance: string) => distance.replace(' ', '');

// removes first and third spaces, to format both "3 mins" and "1 hour 7 mins" to figma spec
const formatDuration = (duration: string) =>
  duration.replace(/(\d+)\s+([a-z]+)/gi, '$1$2');

const TravelTime: React.FC<TravelTimeProps> = ({ itemId }) => {
  const { routeInfo, travelMode } = useContext(TourEditContext);

  const travelInfoForStop = routeInfo[itemId] ?? null;

  if (travelInfoForStop) {
    return (
      <>
        <StyledContainer $travelMode={travelMode}>
          <Icon
            type={
              travelMode === google.maps.TravelMode.DRIVING ? 'car' : 'walking'
            }
            width={12}
            offset={[0, 0]}
          />
          {formatDistance(travelInfoForStop.distance)}
          <DotSeparator marginX={3} />{' '}
          {formatDuration(travelInfoForStop.duration)}
        </StyledContainer>
        <StyledDivider />
      </>
    );
  }

  return null;
};

export default TravelTime;

const StyledContainer = styled.div<{ $travelMode: google.maps.TravelMode }>`
  font-size: 12px;
  margin-top: 10px;
  color: ${theme.gray8};
  svg {
    margin-right: ${({ $travelMode }) =>
      $travelMode === google.maps.TravelMode.DRIVING ? '10px' : '7px'};
  }
`;
